/*
 * @Author: Chao Yang
 * @Date: 2021-01-10 20:42:05
 * @LastEditor: Chao Yang
 * @LastEditTime: 2021-01-10 20:49:47
 */

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MenuOption, MenuItem } from 'section';
import { MenuProxy } from 'src/app/domain/proxy/menu/menu.proxy';
import { InfoService } from 'src/app/domain/service/info/info.service';

@Injectable()
export class MenuService {
  constructor(private infoService: InfoService, private menuProxy: MenuProxy) {}

  getMenuOption(): Observable<MenuOption> {
    return this.menuProxy.getMenus().pipe(
      map((menus) => {
        const menuOption = new MenuOption();
        menuOption.branding = this.infoService.info.branding.name;
        menus.forEach((menu) => {
          const mainMenu = new MenuItem();
          mainMenu.text = menu.text;
          mainMenu.link = menu.link;
          mainMenu.iconClass = menu.iconClass;
          if (menu.setting) {
            mainMenu.isExternal = menu.setting.isExternal;
          } else {
            mainMenu.isExternal = false;
          }
          menuOption.menus.push(mainMenu);
        });
        return menuOption;
      })
    );
  }

  getInvestmentMenus(mcpDealId: number): Observable<any> {
    return this.menuProxy.getInvestmentMenus(mcpDealId);
  }
}
